<template>
    <el-carousel ref="webBody" class="axj_web_body" arrow="never" indicator-position="none" :autoplay="false">
      <el-carousel-item class="axj_web_body_page axj_web_body_item" key="page" name="page">
        <body_page/>
      </el-carousel-item>
      <el-carousel-item class="axj_web_body_login axj_web_body_item" key="login" name="login">
        <body_login/>
      </el-carousel-item>
      <el-carousel-item class="axj_web_body_about axj_web_body_item" key="about" name="about">
        <body_about/>
      </el-carousel-item>
    </el-carousel>
</template>

<script>
import Body_page from "./component/body_page/index";
import Body_about from "./component/body_about/index";
import Body_login from "./component/body_login/index";
export default {
  name: "axj_web_body",
  components: {Body_login, Body_about, Body_page},
  props:{
    activeItem:{
      type:String,
      default:'page'
    }
  },
  computed:{

  },
  watch:{
    activeItem(v){
      this.$refs.webBody.setActiveItem(v)
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj_web_body{
  flex: 1;
  .axj_web_body_item{
  }
  .el-carousel__container{
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/component/web_body/index.vue